import { useRef, useEffect } from 'react';
import _isBoolean from 'lodash/isBoolean';
import _isFunction from 'lodash/isFunction';
export default function useEventListener(eventName, handler) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    elementProp = _ref.element,
    _ref$once = _ref.once,
    once = _ref$once === void 0 ? false : _ref$once;
  // Create a ref that stores handler
  var savedHandlerRef = useRef();
  var savedOnceRef = useRef();

  // Update ref.current value if handler changes.
  useEffect(function () {
    savedHandlerRef.current = handler;
  }, [handler]);
  useEffect(function () {
    savedOnceRef.current = once;
  }, [once]);
  useEffect(function () {
    var unsubscribe = null;

    // Make sure element supports addEventListener
    var element = elementProp || window;
    var isSupported = element && element.addEventListener;
    if (!isSupported) return undefined;
    var eventListener = function eventListener(event) {
      if (_isFunction(savedHandlerRef.current)) {
        savedHandlerRef.current(event, {
          unsubscribe: unsubscribe
        });
      }
      if (_isBoolean(savedOnceRef.current) && savedOnceRef.current) {
        unsubscribe();
      }
      if (_isFunction(savedOnceRef.current)) {
        if (savedOnceRef.current(event)) {
          unsubscribe();
        }
      }
    };
    element.addEventListener(eventName, eventListener);
    unsubscribe = function unsubscribe() {
      element.removeEventListener(eventName, eventListener);
    };
    return function () {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [eventName, elementProp, once]);
}